import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
       
<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M5046 9585 c-30 -11 -113 -87 -345 -319 l-306 -306 -735 0 c-693 0
-737 -1 -775 -19 -46 -21 -79 -54 -94 -94 -7 -19 -11 -227 -11 -625 l0 -597
-330 -330 c-220 -221 -334 -342 -345 -367 -20 -50 -19 -101 4 -146 11 -20 166
-183 345 -362 l326 -325 0 -596 0 -596 23 -44 c17 -34 35 -50 77 -71 l54 -28
665 0 666 0 380 -380 c372 -372 381 -380 432 -391 104 -24 95 -30 518 392
l380 378 686 3 686 3 37 29 c78 59 76 37 76 704 l0 594 322 329 c176 180 329
341 340 356 29 45 25 129 -11 184 -16 24 -169 183 -340 354 l-311 310 0 597
c0 398 -4 606 -11 625 -15 40 -48 73 -94 94 -38 18 -82 19 -775 19 l-734 0
-311 309 c-259 258 -317 311 -350 320 -53 14 -91 13 -139 -4z m364 -669 c157
-157 298 -290 313 -295 19 -7 257 -11 717 -11 l689 0 1 -551 c0 -303 4 -558 9
-566 4 -8 146 -153 314 -322 l307 -306 -301 -300 c-165 -165 -307 -312 -315
-327 -12 -23 -14 -119 -14 -578 l0 -550 -582 2 -581 3 -62 200 c-34 110 -85
272 -113 360 -83 260 -291 926 -423 1350 l-68 219 50 53 c71 75 93 129 94 228
0 68 -4 89 -28 137 -55 113 -168 182 -297 182 -131 -1 -234 -65 -292 -182 -28
-57 -33 -77 -33 -138 1 -59 6 -82 33 -136 18 -36 50 -82 72 -102 22 -20 40
-40 40 -44 0 -4 -15 -55 -34 -113 -18 -57 -61 -192 -95 -299 -34 -107 -109
-341 -166 -520 -57 -179 -136 -426 -175 -550 -39 -124 -80 -250 -90 -280 -24
-72 -62 -196 -90 -292 l-23 -78 -578 0 -579 0 0 551 c0 382 -3 557 -11 572 -6
12 -148 159 -315 327 l-304 305 301 300 c165 165 307 312 315 327 12 23 14
118 14 573 l0 545 689 0 c428 0 700 4 716 10 14 5 155 138 313 295 158 156
289 285 292 285 2 0 133 -128 290 -284z m-277 -1878 c3 -13 30 -104 61 -203
31 -98 56 -184 56 -190 0 -5 -29 -41 -65 -80 l-65 -70 -70 74 c-49 51 -69 79
-65 90 4 9 34 105 68 213 34 108 64 195 68 192 4 -2 9 -14 12 -26z m-162 -710
c7 -13 -6 -29 -63 -80 -46 -41 -69 -56 -66 -43 4 11 19 62 35 113 l28 93 28
-33 c16 -18 33 -40 38 -50z m369 55 c1 -10 14 -56 30 -103 15 -47 26 -87 24
-89 -3 -3 -33 24 -69 59 l-63 63 31 43 c35 47 47 54 47 27z m-31 -401 c5 -3
-2 -8 -113 -88 -55 -41 -82 -55 -91 -48 -7 5 -52 36 -99 69 l-87 59 98 98 98
98 94 -93 c53 -50 97 -93 100 -95z m-481 -212 c50 -36 92 -68 92 -71 0 -4 -70
-59 -155 -123 -85 -64 -155 -113 -155 -109 0 5 25 84 55 178 30 93 55 175 55
183 0 18 2 17 108 -58z m740 -112 c33 -101 58 -185 56 -187 -2 -2 -40 24 -86
58 -46 34 -116 85 -155 113 -40 29 -73 54 -72 57 0 7 181 139 191 140 4 1 34
-81 66 -181z m-363 -162 c39 -28 186 -138 328 -245 l259 -194 -339 -339 -338
-338 -337 337 c-185 185 -335 339 -333 341 35 35 673 498 680 494 5 -3 42 -29
80 -56z"/>
<path d="M6000 8377 c-47 -16 -83 -71 -76 -115 3 -19 17 -48 31 -65 14 -18 48
-59 75 -92 57 -67 131 -211 155 -300 10 -34 19 -119 22 -197 5 -120 3 -149
-17 -230 -36 -152 -109 -291 -209 -402 -58 -64 -71 -107 -47 -154 34 -67 110
-82 176 -37 83 57 217 257 268 398 56 154 67 225 66 412 0 142 -4 183 -22 249
-41 146 -134 319 -240 444 -75 88 -119 110 -182 89z"/>
<path d="M4086 8308 c-233 -236 -336 -568 -281 -908 37 -226 137 -432 283
-581 56 -57 73 -69 100 -69 71 0 122 48 122 116 0 36 -8 51 -70 125 -132 158
-199 333 -208 539 -7 177 15 285 85 425 43 85 75 132 142 208 46 53 51 63 51
107 0 42 -4 51 -35 79 -28 24 -45 31 -76 31 -38 0 -47 -6 -113 -72z"/>
<path d="M5653 8080 c-70 -42 -72 -102 -7 -186 65 -84 90 -130 108 -200 40
-155 -2 -327 -106 -440 -54 -59 -63 -115 -24 -161 45 -53 115 -55 171 -5 76
67 130 155 176 282 20 56 23 84 23 205 0 126 -2 147 -26 213 -61 169 -183 312
-265 312 -10 0 -32 -9 -50 -20z"/>
<path d="M4490 8082 c-62 -30 -152 -139 -195 -236 -45 -101 -58 -178 -52 -306
8 -177 63 -313 170 -427 55 -57 67 -65 108 -70 38 -4 50 -1 77 22 58 49 53
109 -17 193 -83 100 -117 206 -108 341 6 104 32 177 87 246 74 93 81 107 76
149 -6 51 -41 86 -92 92 -21 2 -46 0 -54 -4z"/>
<path d="M1655 3838 c-22 -60 -325 -965 -325 -970 0 -5 51 -8 114 -8 l115 0
33 101 33 100 175 0 174 0 33 -98 c18 -54 33 -99 33 -100 0 -2 52 -3 115 -3
63 0 115 1 115 3 0 1 -30 88 -66 192 -36 105 -112 325 -169 490 l-103 300
-136 3 c-104 2 -138 -1 -141 -10z m142 -586 c-60 -1 -111 -1 -113 1 -3 3 67
233 103 337 3 8 31 -64 62 -160 l58 -175 -110 -3z"/>
<path d="M2380 3355 l0 -495 300 0 300 0 0 100 0 100 -185 0 -185 0 0 395 0
395 -115 0 -115 0 0 -495z"/>
<path d="M3090 3355 l0 -495 120 0 120 0 0 166 c0 148 2 168 19 190 l19 25
120 -168 c65 -92 125 -178 133 -190 13 -22 19 -23 157 -23 79 0 142 3 140 8
-1 4 -90 123 -196 264 -135 179 -191 261 -185 271 9 14 162 215 275 360 l68
87 -138 0 -137 0 -135 -182 -135 -183 -3 183 -2 182 -120 0 -120 0 0 -495z"/>
<path d="M4010 3355 l0 -495 110 0 110 0 0 210 0 210 175 0 175 0 0 -210 0
-210 115 0 115 0 0 495 0 495 -115 0 -115 0 0 -185 0 -185 -175 0 -175 0 0
185 0 185 -110 0 -110 0 0 -495z"/>
<path d="M5162 3602 c-46 -136 -121 -357 -167 -492 -47 -135 -85 -246 -85
-247 0 -2 52 -3 115 -3 l114 0 32 100 32 100 178 0 178 0 32 -100 32 -100 113
0 c63 0 114 3 114 8 0 4 -43 133 -96 287 -118 346 -234 689 -234 692 0 2 -62
3 -137 3 l-138 0 -83 -248z m279 -177 l57 -175 -118 0 -118 0 57 175 c31 96
58 174 61 174 3 0 30 -78 61 -174z"/>
<path d="M5965 3355 l0 -495 113 0 112 0 0 495 0 495 -112 0 -113 0 0 -495z"/>
<path d="M6380 3356 l0 -496 110 0 110 0 0 185 0 185 58 0 57 0 98 -185 99
-185 119 0 c65 0 119 2 119 5 0 2 -20 42 -44 87 -24 46 -69 131 -100 190 -59
112 -64 128 -43 128 28 1 104 69 132 121 27 49 30 62 30 149 0 87 -3 100 -30
149 -33 60 -94 111 -165 137 -36 14 -93 18 -297 22 l-253 4 0 -496z m443 291
c63 -27 86 -110 47 -174 -24 -41 -94 -63 -197 -63 l-73 0 0 123 c0 68 3 127 7
130 11 12 179 -1 216 -16z"/>
<path d="M7519 3723 c-23 -71 -98 -292 -166 -492 -67 -200 -123 -366 -123
-368 0 -1 52 -3 115 -3 l114 0 11 43 c6 23 20 68 31 99 l21 57 163 3 c89 2
169 2 177 0 8 -2 27 -44 47 -102 l32 -100 115 0 c63 0 114 4 114 9 0 5 -40
124 -89 263 -49 139 -124 358 -167 485 l-79 233 -137 0 -136 0 -43 -127z m235
-291 c31 -93 56 -172 56 -175 0 -4 -52 -7 -115 -7 -63 0 -115 2 -115 4 0 10
111 346 115 346 2 0 28 -76 59 -168z"/>
<path d="M8090 3755 l0 -95 140 0 140 0 0 -400 0 -400 115 0 115 0 0 400 0
400 130 0 130 0 0 95 0 95 -385 0 -385 0 0 -95z"/>
<path d="M3180 2026 l0 -556 239 0 c279 0 358 11 471 67 134 66 230 187 265
335 17 75 19 236 4 310 -29 138 -128 270 -246 328 -121 59 -143 62 -450 67
l-283 5 0 -556z m540 309 c119 -48 180 -137 188 -275 8 -139 -28 -230 -116
-297 -59 -44 -128 -64 -254 -70 l-108 -6 0 338 0 337 123 -4 c86 -3 135 -10
167 -23z"/>
<path d="M4541 2423 c-29 -87 -82 -239 -116 -338 -150 -430 -203 -581 -210
-597 -7 -17 3 -18 129 -18 100 0 136 3 136 12 0 7 14 59 32 115 l32 103 206 0
205 0 35 -113 36 -112 132 -3 c73 -1 132 -1 132 1 0 3 -7 24 -16 48 -9 24 -76
220 -149 434 -73 215 -151 442 -172 505 l-40 115 -159 3 -159 2 -54 -157z
m273 -296 c32 -100 61 -190 64 -199 4 -17 -7 -18 -127 -18 -72 0 -131 3 -131
7 0 17 124 393 129 393 3 0 33 -82 65 -183z"/>
<path d="M5210 2470 l0 -110 155 0 155 0 0 -445 0 -445 125 0 125 0 0 445 0
445 155 0 155 0 0 110 0 110 -435 0 -435 0 0 -110z"/>
<path d="M6359 2553 c-6 -16 -66 -190 -134 -388 -68 -198 -149 -431 -179 -518
-31 -87 -56 -162 -56 -168 0 -5 54 -9 128 -9 l127 0 35 113 35 112 205 3 206
2 37 -115 38 -115 129 0 129 0 -40 118 c-23 64 -103 299 -179 522 -76 223
-144 420 -150 438 l-12 32 -154 0 -154 0 -11 -27z m225 -426 c32 -100 61 -190
64 -199 4 -17 -7 -18 -128 -18 l-131 0 6 23 c4 12 32 97 61 188 30 91 54 171
54 177 0 41 22 -11 74 -171z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
